import { Link } from '@tanstack/react-router';
import { brandOriginUrl } from '@/api';
import { casinoCategoryPath, casinoVendorLogoUrl } from '@/domain';
import { cn } from '@/lib/cn';
import { Icon } from '@/ui/common';

export interface SelectedProviderBarProps {
  vendorName: string;
  category: string;
  className?: string;
}

export function SelectedProviderBar({ vendorName, category, className }: SelectedProviderBarProps) {
  return (
    <div
      className={cn(
        'flex h-[60px] items-center justify-between gap-3 rounded-md border border-border-default bg-bg-surface px-4',
        className,
      )}
    >
      <div className="flex min-w-0 items-center gap-3">
        <img
          src={casinoVendorLogoUrl(brandOriginUrl(), vendorName)}
          alt=""
          className="h-8 max-w-[96px] object-contain"
          onError={(event) => {
            event.currentTarget.style.display = 'none';
          }}
        />
        <p className="truncate text-body-s font-bold text-text-primary">{vendorName}</p>
      </div>
      <Link
        to={casinoCategoryPath(category)}
        className="inline-flex size-10 items-center justify-center rounded-md text-text-secondary hover:bg-bg-elevated hover:text-text-primary"
        aria-label="Clear provider filter"
      >
        <Icon name="close" size={20} />
      </Link>
    </div>
  );
}
